// Module
var code = "<button type=\"button\" class=\"odds-button\"/>";
// Exports
export default code;